<template>
  <div class="header-wrapper">
    <div class="head-cont">
      <!-- <img src="../../../assets/images/logoTN.png" alt="" /> -->
      <img src="../../../assets/images/logo.png" alt="" />
      <div class="nav-list">
        <!-- <div @click="changeColor">微信公众号</div> -->
        <div @click="toLinkgw()">{{ $t("common.title") }}</div>
        <!-- <div @click="toLink(taobao)">{{ $t("common.tb") }}</div> -->
        <!-- https://shop375613435.taobao.com/ -->
        <div @click="jx()">{{ $t("common.jx") }}</div>
        <!-- <div @click="qiehuan">{{ $t("common.yy") }}</div> -->
        <div @click="yuyan = true">{{$t("yyqh")}}</div>
        <div  style="position: absolute; top: 39px;right: 510px;" >
          <!-- <Select v-model="sz"  @on-change="showyy()" style="width:120px;">
              <Option :value="it.CountryID" v-for="(it, int) in syck" :key="int" > {{ it.CountryName }}</Option>
          </Select> -->
          <Modal v-model="yuyan" :title="$t('common.choseLanguage')">
              <div class="MpadIV">
                <p v-for="(it, int) in syck" :key="int" @click="showyy(int)" class="MoaP">{{ it.CountryName }}</p>
              </div>
          </Modal>
        </div>
        <!-- 登录  -->
        <div @click="loginone" v-if="!login" class="isShowLogin">{{ $t("login.three") }}</div>
        <!-- 退出 -->
        <div @click="tz()" v-if="login" class="isShowLogin">{{ $t("common.tc") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameUserInfo: null,
      taobao: "https://shop375613435.taobao.com",
      gw: "http://www.best-muster.com/",
      login: false,
      yuyan:false,
      showBtn: false,
      syck: [
        {
          CountryID: 1,
          CountryName: this.$t('common.ChineseLanguage'),
        },
        {
          CountryID: 2,
          CountryName: this.$t('common.TraditionalChinese'),
        },
        {
          CountryID: 3,
          CountryName: this.$t('common.English'),
        },
      ],
    };
  },
  created() {
    if (localStorage.getItem("userID")) {
      this.login = true;
    } else {
      this.login = false;
    }
  },
  methods: {
    jx(){
      this.$router.push("./noviceguidance")
    },
    showyy(int) {
      if (int == 0) {
        this.$i18n.locale = "zh";
        // 对应main.js配置文件中的localStorage的get方法
        localStorage.setItem("locale", "zh");
        this.yuyan = false;
      }
      if (int == 1) {
        this.$i18n.locale = "en";
        // 对应main.js配置文件中的localStorage的get方法
        localStorage.setItem("locale", "en");
        this.yuyan = false;
      }
      if (int == 2) {
        this.$i18n.locale = "tw";
        // 对应main.js配置文件中的localStorage的get方法
        localStorage.setItem("locale", "tw");
        this.yuyan = false;
      }
    },
    // 这个方法
    loginone(route) {
      this.showBtn = !this.showBtn;
      this.$emit("getIsshow", this.showBtn);
    },
    qiehuan() {
      if (!localStorage.getItem("locale") || localStorage.getItem("locale") == "zh") {
        this.$i18n.locale = "en";
        localStorage.setItem("locale", "en");
      } else {
        this.$i18n.locale = "zh";
        localStorage.setItem("locale", "zh");
      }
    },
    changeColor() {
      window.document.documentElement.setAttribute("data-theme", "primary2");
    },
    toLink() {
      // window.open(
      //   "https://shop218704603.taobao.com/?spm=a230r.7195193.1997079397.2.224d5750khWhgk"
      // );
    },
    toLinkgw() {
      window.open(
        "http://www.best-muster.com/"
      );
    },
    tz() {
      localStorage.removeItem("CusID");
      localStorage.removeItem("userID");
      localStorage.removeItem("KeyText");
      localStorage.removeItem("token");
      this.$router.push("./login");
    },
  },
};
</script>
<style lang="scss" scoped>
.MpadIV{
  width: 400px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.MoaP:hover {
  cursor: pointer;
}
.header-wrapper {
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 16px;
  color: #000;
  background: #fff;
  // @include backgroundColor($_color);
  .head-cont {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    img {
      width: 195px;
      position: relative;
      left: -390px;
      height: 78px;
      cursor: pointer;
    }
    .nav-list {
      display: flex;
      flex-direction: row;
      > div {
        // color:#fff;
        margin-left: 56px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/header/index.vue